import { Group, Image } from '@mantine/core';
import clsx from 'clsx';
import { FC } from 'react';

import ChatAnimation from '@assets/animations/chat.gif';
import PlatformAvatar from '@assets/avatar.png';
import NoResultsSuggestions from '../NoResultsSuggestions';

import { IMessage, MessageStatus } from '../../state';
import styles from './index.module.css';

interface IProps {
  message: IMessage;
}

const Message: FC<IProps> = ({
  message: { isUserMessage, message, status, type }
}) => {
  return (
    <div className={clsx(styles.container, [{ [styles.right]: isUserMessage }])}>
      {!isUserMessage && (
        <Group>
          <Image src={PlatformAvatar} h={35} w="auto" />
        </Group>
      )}
      {status === MessageStatus.Calculating ? (
        <Image src={ChatAnimation} h={45} w="auto" mt="-10px" />
      ) : type === 'no-results-suggestions' ? (
        <div
          className={clsx(styles.message, [
            {
              [styles['platform-message']]: !isUserMessage,
              [styles['user-message']]: isUserMessage
            }
          ])}
        >
          <NoResultsSuggestions />
        </div>
      ) : (
        <div
          className={clsx(styles.message, [
            {
              [styles['platform-message']]: !isUserMessage,
              [styles['user-message']]: isUserMessage
            }
          ])}
          dangerouslySetInnerHTML={{ __html: message ?? '' }}
        ></div>
      )}
    </div>
  );
};

export default Message;
